import {h, Fragment} from "preact"
import { useAppState, useProductFilters } from "@nosto/preact"
import { useEffect, useMemo, useState } from "preact/hooks";
import Product from "./Product"
import Product_new from "./Product_new"
import { searchRefColors } from "../config"

export default function Products() {
    const { response: { products }, loading, query, pageType } = useAppState(); 
    const { filters } = useProductFilters();
    const [colorInQuery, setColorInQuery] = useState()

    var abtest = document.getElementById('abtest') != null; 

    // const colorInQuery = useMemo(() => {
    //     if(pageType !== 'search' || typeof query?.query !== 'string' || query?.query?.length < 3) return null;
    //     const lowerCasedQuery = query?.query.toLowerCase();
    //     const foundColorsInQuery = searchRefColors?.filter(color => lowerCasedQuery?.includes(color));
    //     if(foundColorsInQuery.length === 1) {
    //         return foundColorsInQuery[0]
    //     } else if (foundColorsInQuery.length > 1) {
    //         let firstColorMatch = null;
    //         let firstIndex = lowerCasedQuery?.length;
    //         for(const color of searchRefColors) {
    //             const index = lowerCasedQuery.indexOf(color);
    //             if(index !== -1 && index < firstIndex) {
    //                 firstColorMatch = color;
    //                 firstIndex = index;
    //             }
    //         }
    //         return firstColorMatch
    //     } else {
    //         return null
    //     }
    // }, [ query?.query, pageType, searchRefColors ])

    useEffect(() => {
        if(pageType == 'search' || query?.query || query?.query?.length < 3){
            const lowerCasedQuery = query?.query.toLowerCase();
            const foundColorsInQuery = searchRefColors?.filter(color => lowerCasedQuery?.includes(color));
            if(foundColorsInQuery.length === 1 && foundColorsInQuery[0] !== colorInQuery) {
                setColorInQuery(foundColorsInQuery[0])
            } else if (foundColorsInQuery.length > 1) {
                let firstColorMatch = null;
                let firstIndex = lowerCasedQuery?.length;
                for(const color of searchRefColors) {
                    const index = lowerCasedQuery.indexOf(color);
                    if(index !== -1 && index < firstIndex) {
                        firstColorMatch = color;
                        firstIndex = index;
                    }
                }
                setColorInQuery(firstColorMatch)
            } 
            // else {
            //     return null
            // }
        }
    }, [ query?.query, pageType, searchRefColors ])

    const filterColor = useMemo(() => {
        const colorFilters = filters?.filter(f => f.name === 'Color');
        if(colorFilters.length >= 1) {
            const lastColorFilter = colorFilters[colorFilters.length - 1];
            return lastColorFilter.value;
        } else {
            return null;
        }
    }, [ filters ])
    
    useEffect(() => { // removes page skeleton and unhides Nosto when products render
        if(pageType === 'category') {
            document.getElementById('collection-skel__container')?.classList?.add('hidden');
            document.getElementById('nostoTargetPLP')?.classList?.remove('hidden')
        }
    }, [])

    useEffect(() => {
        if(typeof window.nostojs === 'function') {
            window.nostojs(api => {
                api.loadRecommendations({ skipPageViews: true })
            })
        }
    }, [ products.hits ])

    useEffect(() => { // wishlist api 
        console.log('swym init')
        console.log(products);
        if(products?.hits?.length < 1) return;
       
        const onSwymLoadCallback = (swat) => {
            if (swat && typeof swat.initializeActionButtons === 'function') {
                swat.initializeActionButtons('.ns-serp', '[ns-wishlist-btn]');
            }
        };
      
        if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
        }
        window.SwymCallbacks.push(onSwymLoadCallback);
        console.log(document.getElementById('abtest'));
    }, [ products?.hits ]);

    return (
        <div id="ns-product-grid" class="ns-flex ns-flex-wrap ns-w-full " rel={abtest} style={loading ? "opacity: 0.3;" : ""}>
            {products.hits.map((hit, index) => (
                window.abtest ? <Product_new
                key={hit.productId || index} 
                product={hit} 
                activeColor={filterColor || colorInQuery}
            /> : <Product
                    key={hit.productId || index} 
                    product={hit} 
                    activeColor={filterColor || colorInQuery}
                />
            ))}
        </div>
    )
}
